import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

// Store Board (Audit -> Store Board) — reads the read-only Admin_GetStoreBoard proc on db37
// which returns the whole board (KPIs, tender split, pipeline, GST, receivables, stores,
// customers, daily billing, and every billed order with its live custody stage) as one JSON
// object. Same token-refresh pattern as emplaundrybenefitservice / rto3service.
export default class StoreBoardService {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  // fromDate/toDate = "YYYY-MM-DD" (toDate INCLUSIVE); storeId 0 = all stores.
  // basis = "billing" (by invoice date, default) | "order" (by order-created date).
  async getBoard(fromDate, toDate, storeId, basis, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_STORE_BOARD });
    let out = {};
    await api.endpoints[this.endpoint.GET_STORE_BOARD]
      .getAllPost({ FromDate: fromDate || "", ToDate: toDate || "", StoreID: storeId || 0, Basis: basis === "order" ? "order" : "billing" })
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });

    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getBoard(fromDate, toDate, storeId, basis, true);
        return out;
      } catch (e) {
        return { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    // WebAPI returns the board as a JSON string in Data (System.Text.Json can't serialize a raw
    // JToken). Parse it here so the component gets a plain object.
    if (out && typeof out.data === "string") {
      try {
        return JSON.parse(out.data);
      } catch (e) {
        return { error: "Could not parse Store Board response." };
      }
    }
    return out && out.data !== undefined ? out.data : out;
  }
}
